import { Modal, Form, Input, Alert } from 'antd'
import React from 'react'
import PropTypes from 'prop-types'
import toClass from 'recompose/toClass'

const FormItem = Form.Item

function CloudApiComponent(props) {
  const { chatbot, organization, form, editingRecord, ...rest } = props

  return (
    <Modal {...rest} okText="Yes" cancelText="No">
      <Form layout="vertical">
        {
          organization != undefined ? 
            <FormItem label="Organization">
              {organization}
            </FormItem> : <></>
        }
        <FormItem label="ChatBot">
          {chatbot}
        </FormItem>
        <FormItem>
          <Alert
            message="Careful!"
            description="Are you sure you want to migrate this PhoneNumer to CloudApi?"
            type="warning"
            showIcon/>
        </FormItem>
      </Form>
    </Modal>
  )
}

export const CloudApiModal = Form.create({
  mapPropsToFields: ({ record }) => Object.keys(record).reduce((xs, x) => ({ ...xs, [x]: Form.createFormField({ value: record[x] }) }), {}),
})(toClass(CloudApiComponent))

CloudApiComponent.propTypes = {
  record: PropTypes.object,
  form: PropTypes.any,
  editingRecord: PropTypes.object,
  type: PropTypes.string,
  organization: PropTypes.string,
  chatbot: PropTypes.string,
}
